// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1GwPJ","errors":"Errors_errors__17LaK"};